import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService, AlertService } from 'ngx-venus';
import { GeneralService } from '@app/core/http';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute, Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
})
export class TestComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService,
    private generalService: GeneralService,
    private route: ActivatedRoute,
    public alertService: AlertService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.authService.flush();

    // set apikey
    let apiKey = '';
    if (this.route.snapshot.queryParams['apikey']) {
      apiKey = this.route.snapshot.queryParams['apikey'];
    } else {
      apiKey = '53fdc0a83e964b41811e02cd36605897';
    }

    // qa d2d619c371f949c7b00df3370921da0f

    //qa 7337134ce56c4e64b1d5f3570637a9e7

    //qa 53fdc0a83e964b41811e02cd36605897

    // generate uniq reference number
    const referenceNo =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);

    const amount = Math.floor(Math.random() * 9) + 1211;
    // init params
    const params = {
      referenceNo: referenceNo,
      apiKey: 'd2d619c371f949c7b00df3370921da0f',
      amount: 200,
      country: 'TR',
      currency: 'TRY',
      city: 'Ankara',
      dateOfBirth: '1980-01-01',
      email: 'test@luqapay.com',
      firstName: 'Ahmet',
      lastName: 'Test',
      language: 'TR',
      address: 'Kizilay Caddesi',
      postCode: '06010',
      failRedirectUrl: 'https://www.example.com',
      successRedirectUrl: 'https://www.example.com',
      // "defaultPaymentMethod":"APP_PAY"
      // amount: 100,
      // country: 'JP',
      // currency: 'JPY',
      // postCode: '68506250',
      // dateOfBirth: '1980-01-01',
      // email: 'test@mail.com',
      // firstName: 'Evelyn Cavalcanti',
      // lastName: 'Melo',
      // language: 'EN',
      // state: 'SP',
      // defaultPaymentMethod: 'APP_PAY',
      // defaultPaymentMethod: 'INDIAN_ATM',
      // apiKey: '7337134ce56c4e64b1d5f3570637a9e7',
      // amount: 96.75,
      // country: 'GB',
      // currency: 'EUR',
      // city: 'test',
      // language: 'EN',
      // postCode: '01311100',
      // dateOfBirth: '1981-06-19',
      // email: 'outlooktestw@freelancer.com',
      // address: 'test-6',
      // firstName: 'Test trn',
      // lastName: 'Test',
      // referenceNo: referenceNo,
      // state: 'test',
      // failRedirectUrl:
      // defaultPaymentMethod: 'MANUAL_BANK_TRANSFER',
      // cardNumber: '5500000000000004',
      // pin: '123',
      // expDate: '12-25',
    };

    this.generalService
      .initializeTransaction(params)
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        if (response && response.redirectUrl) {
          const url =
            'init-payment' + response.redirectUrl.split('init-payment')[1];
          window.location.href = url;
        } else {
          this.alertService.setNotice(response.message);
          this.router.navigate(['404']);
        }
      });
  }

  ngOnDestroy() {}
}
